import { Component, HostListener, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { OidcAuthService } from 'baseflow-auth';
import { Observable, of } from 'rxjs';

import { TWizardStepId } from '../../../interfaces';
import { WizardStepBaseComponent } from '../base/wizard-step-base.component';

@Component({
    selector: 'app-wizard-step-login',
    templateUrl: './wizard-step-login.component.html',
    styleUrls: ['../base/wizard-step-base.component.scss', 'wizard-step-login.component.scss'],
    imports: [TranslatePipe],
})
export class WizardStepLoginComponent extends WizardStepBaseComponent {
    private readonly oidcAuthService = inject(OidcAuthService);

    public id: TWizardStepId = 'login';

    public nextButtonLabel = 'login';

    @HostListener('keyup.enter')
    public onSubmit(): void {
        this.stepSubmit.emit();
    }

    protected submitWizardStep(): Observable<boolean> {
        this.oidcAuthService.login();
        return of(false);
    }
}
